/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WeaknessBlastRadiusAssetDto } from './WeaknessBlastRadiusAssetDto';
import {
    WeaknessBlastRadiusAssetDtoFromJSON,
    WeaknessBlastRadiusAssetDtoFromJSONTyped,
    WeaknessBlastRadiusAssetDtoToJSON,
    WeaknessBlastRadiusAssetDtoToJSONTyped,
} from './WeaknessBlastRadiusAssetDto';
import type { ContainerGraphEdgeDto } from './ContainerGraphEdgeDto';
import {
    ContainerGraphEdgeDtoFromJSON,
    ContainerGraphEdgeDtoFromJSONTyped,
    ContainerGraphEdgeDtoToJSON,
    ContainerGraphEdgeDtoToJSONTyped,
} from './ContainerGraphEdgeDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { UserHostGraphTraversalResponse } from './UserHostGraphTraversalResponse';
import {
    UserHostGraphTraversalResponseFromJSON,
    UserHostGraphTraversalResponseFromJSONTyped,
    UserHostGraphTraversalResponseToJSON,
    UserHostGraphTraversalResponseToJSONTyped,
} from './UserHostGraphTraversalResponse';
import type { OpenWeaknessCountSnapshot } from './OpenWeaknessCountSnapshot';
import {
    OpenWeaknessCountSnapshotFromJSON,
    OpenWeaknessCountSnapshotFromJSONTyped,
    OpenWeaknessCountSnapshotToJSON,
    OpenWeaknessCountSnapshotToJSONTyped,
} from './OpenWeaknessCountSnapshot';

/**
 * 
 * @export
 * @interface WeaknessBlastRadiusResponse
 */
export interface WeaknessBlastRadiusResponse {
    /**
     * 
     * @type {string}
     * @memberof WeaknessBlastRadiusResponse
     */
    weaknessGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessBlastRadiusResponse
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessBlastRadiusResponse
     */
    framework?: string;
    /**
     * 
     * @type {number}
     * @memberof WeaknessBlastRadiusResponse
     */
    openFindingCount?: number;
    /**
     * 
     * @type {OpenWeaknessCountSnapshot}
     * @memberof WeaknessBlastRadiusResponse
     */
    severityBreakdown?: OpenWeaknessCountSnapshot;
    /**
     * 
     * @type {Array<WeaknessBlastRadiusAssetDto>}
     * @memberof WeaknessBlastRadiusResponse
     */
    hosts?: Array<WeaknessBlastRadiusAssetDto>;
    /**
     * 
     * @type {Array<WeaknessBlastRadiusAssetDto>}
     * @memberof WeaknessBlastRadiusResponse
     */
    containerImages?: Array<WeaknessBlastRadiusAssetDto>;
    /**
     * 
     * @type {Array<WeaknessBlastRadiusAssetDto>}
     * @memberof WeaknessBlastRadiusResponse
     */
    containerWorkloads?: Array<WeaknessBlastRadiusAssetDto>;
    /**
     * 
     * @type {Array<WeaknessBlastRadiusAssetDto>}
     * @memberof WeaknessBlastRadiusResponse
     */
    users?: Array<WeaknessBlastRadiusAssetDto>;
    /**
     * 
     * @type {Array<WeaknessBlastRadiusAssetDto>}
     * @memberof WeaknessBlastRadiusResponse
     */
    derivedHosts?: Array<WeaknessBlastRadiusAssetDto>;
    /**
     * 
     * @type {Array<ContainerGraphEdgeDto>}
     * @memberof WeaknessBlastRadiusResponse
     */
    graphEdges?: Array<ContainerGraphEdgeDto>;
    /**
     * 
     * @type {UserHostGraphTraversalResponse}
     * @memberof WeaknessBlastRadiusResponse
     */
    personTraversal?: UserHostGraphTraversalResponse;
    /**
     * 
     * @type {number}
     * @memberof WeaknessBlastRadiusResponse
     */
    queryDurationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof WeaknessBlastRadiusResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof WeaknessBlastRadiusResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof WeaknessBlastRadiusResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof WeaknessBlastRadiusResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the WeaknessBlastRadiusResponse interface.
 */
export function instanceOfWeaknessBlastRadiusResponse(value: object): value is WeaknessBlastRadiusResponse {
    return true;
}

export function WeaknessBlastRadiusResponseFromJSON(json: any): WeaknessBlastRadiusResponse {
    return WeaknessBlastRadiusResponseFromJSONTyped(json, false);
}

export function WeaknessBlastRadiusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeaknessBlastRadiusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'weaknessGoldenId': json['weaknessGoldenId'] == null ? undefined : json['weaknessGoldenId'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'framework': json['framework'] == null ? undefined : json['framework'],
        'openFindingCount': json['openFindingCount'] == null ? undefined : json['openFindingCount'],
        'severityBreakdown': json['severityBreakdown'] == null ? undefined : OpenWeaknessCountSnapshotFromJSON(json['severityBreakdown']),
        'hosts': json['hosts'] == null ? undefined : ((json['hosts'] as Array<any>).map(WeaknessBlastRadiusAssetDtoFromJSON)),
        'containerImages': json['containerImages'] == null ? undefined : ((json['containerImages'] as Array<any>).map(WeaknessBlastRadiusAssetDtoFromJSON)),
        'containerWorkloads': json['containerWorkloads'] == null ? undefined : ((json['containerWorkloads'] as Array<any>).map(WeaknessBlastRadiusAssetDtoFromJSON)),
        'users': json['users'] == null ? undefined : ((json['users'] as Array<any>).map(WeaknessBlastRadiusAssetDtoFromJSON)),
        'derivedHosts': json['derivedHosts'] == null ? undefined : ((json['derivedHosts'] as Array<any>).map(WeaknessBlastRadiusAssetDtoFromJSON)),
        'graphEdges': json['graphEdges'] == null ? undefined : ((json['graphEdges'] as Array<any>).map(ContainerGraphEdgeDtoFromJSON)),
        'personTraversal': json['personTraversal'] == null ? undefined : UserHostGraphTraversalResponseFromJSON(json['personTraversal']),
        'queryDurationMs': json['queryDurationMs'] == null ? undefined : json['queryDurationMs'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function WeaknessBlastRadiusResponseToJSON(json: any): WeaknessBlastRadiusResponse {
    return WeaknessBlastRadiusResponseToJSONTyped(json, false);
}

export function WeaknessBlastRadiusResponseToJSONTyped(value?: WeaknessBlastRadiusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weaknessGoldenId': value['weaknessGoldenId'],
        'identifier': value['identifier'],
        'framework': value['framework'],
        'openFindingCount': value['openFindingCount'],
        'severityBreakdown': OpenWeaknessCountSnapshotToJSON(value['severityBreakdown']),
        'hosts': value['hosts'] == null ? undefined : ((value['hosts'] as Array<any>).map(WeaknessBlastRadiusAssetDtoToJSON)),
        'containerImages': value['containerImages'] == null ? undefined : ((value['containerImages'] as Array<any>).map(WeaknessBlastRadiusAssetDtoToJSON)),
        'containerWorkloads': value['containerWorkloads'] == null ? undefined : ((value['containerWorkloads'] as Array<any>).map(WeaknessBlastRadiusAssetDtoToJSON)),
        'users': value['users'] == null ? undefined : ((value['users'] as Array<any>).map(WeaknessBlastRadiusAssetDtoToJSON)),
        'derivedHosts': value['derivedHosts'] == null ? undefined : ((value['derivedHosts'] as Array<any>).map(WeaknessBlastRadiusAssetDtoToJSON)),
        'graphEdges': value['graphEdges'] == null ? undefined : ((value['graphEdges'] as Array<any>).map(ContainerGraphEdgeDtoToJSON)),
        'personTraversal': UserHostGraphTraversalResponseToJSON(value['personTraversal']),
        'queryDurationMs': value['queryDurationMs'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

